// API timestamps are UTC; older timezone-less ISO timestamps are UTC as well.
export const postDate = (value) => {
  if (typeof value !== 'string' || !value.trim()) return null;
  const raw = value.trim();
  const normalized = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(raw) ? `${raw}Z` : raw;
  const date = new Date(normalized);
  return Number.isFinite(date.getTime()) ? date : null;
};

export const sortCommunityPosts = (posts) => [...(Array.isArray(posts) ? posts : [])].sort((a, b) => {
  // Keep undated legacy posts readable without inventing a posting date.
  const timeOrder = (postDate(a.created_at)?.getTime() ?? -Infinity) - (postDate(b.created_at)?.getTime() ?? -Infinity);
  return timeOrder || String(a.id).localeCompare(String(b.id));
});

export const localDayKey = (value) => {
  const date = value instanceof Date ? value : postDate(value);
  if (!date || !Number.isFinite(date.getTime())) return 'undated';
  return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
};

export const dayLabel = (value, now = Date.now()) => {
  const date = postDate(value);
  if (!date) return 'Date unavailable';
  const today = new Date(now);
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (localDayKey(date) === localDayKey(today)) return 'Today';
  if (localDayKey(date) === localDayKey(yesterday)) return 'Yesterday';
  return new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
};

export const messageTime = (value) => {
  const date = postDate(value);
  return date ? new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(date) : 'Time unavailable';
};

export const absoluteTime = (value) => {
  const date = postDate(value);
  return date ? new Intl.DateTimeFormat(undefined, {
    year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
  }).format(date) : 'Date and time unavailable';
};
